import { LoginForm } from "./LoginForm"
import { EmbeddedLoginForm } from "./EmbeddedLoginForm"
import { useChurchCenterIframe } from "source/shared/hooks/useChurchCenterIframe"
import { LoginFormBaseProps } from "./types"

interface StandardOrEmbeddedLoginFormProps extends LoginFormBaseProps {}

/**
 * StandardOrEmbeddedLoginForm - Adaptive login component
 *
 * Automatically selects the appropriate login implementation based on context:
 * - In iframe/embedded contexts: Uses EmbeddedLoginForm (token-based auth)
 * - In standard contexts: Uses LoginForm (session-based auth)
 *
 * This component should be used in places where login might happen in either
 * context, such as the donation form which can be embedded in iframes.
 */
export function StandardOrEmbeddedLoginForm(
  props: StandardOrEmbeddedLoginFormProps,
) {
  const { inIframe } = useChurchCenterIframe()

  const LoginComponent = inIframe ? EmbeddedLoginForm : LoginForm

  return <LoginComponent {...props} />
}
